import { formatSog, formatCog, formatClockTimeSec, aisShipTypeCategory } from '@boatnav/core';
import type { AisVessel } from '@boatnav/schemas';
import { msg } from '../../lib/messages.js';
import './ais.css';

/**
 * Tap-a-vessel sheet (spec 16): name or MMSI, type label, SOG/KURS, "sist
 * sett", and the delayed-data disclaimer. No following/tracking of other
 * vessels — this is read-only situational awareness.
 */
export function VesselSheet({ vessel, onClose }: { vessel: AisVessel; onClose: () => void }): JSX.Element {
  const title = vessel.name ?? `${msg.ais.mmsiPrefix} ${vessel.mmsi}`;
  const typeLabel = msg.ais.types[aisShipTypeCategory(vessel.shipType)];

  return (
    <div className="sheet-backdrop" onClick={onClose}>
      <div
        className="sheet vessel-sheet"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sheet__handle" />
        <h2 className="sheet__title">{title}</h2>
        <p className="vessel-sheet__type">{typeLabel}</p>

        <div className="vessel-sheet__row">
          <span className="vessel-sheet__label">
            {msg.ais.sog} · {msg.ais.course}
          </span>
          <span className="numeral">
            {formatSog(vessel.sogKn)} kn · {formatCog(vessel.cogDeg)}
          </span>
        </div>
        <div className="vessel-sheet__row">
          <span className="vessel-sheet__label">{msg.ais.lastSeen}</span>
          <span className="numeral">{formatClockTimeSec(vessel.ts)}</span>
        </div>

        <p className="vessel-sheet__disclaimer">{msg.ais.disclaimer}</p>
        <p className="vessel-sheet__attribution">{msg.ais.attribution}</p>

        <button type="button" className="btn btn--ghost vessel-sheet__close" onClick={onClose}>
          {msg.ais.close}
        </button>
      </div>
    </div>
  );
}
